export const ROLES = {
  SUPPORT: 'support',
  MEMBER: 'member',
  READONLY: 'readonly',
  ADMIN: 'admin',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

const KNOWN_ROLES: ReadonlyArray<string> = Object.values(ROLES);

export function parseRole(activeRoleName: string | null | undefined): Role | null {
  if (typeof activeRoleName !== 'string') return null;
  const match = activeRoleName.match(/^\{role:(\w+)\}$/);
  const name = match?.[1];
  return name && KNOWN_ROLES.includes(name) ? (name as Role) : null;
}
